import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="form col-span-6 md:col-span-3 lg:col-span-4">
      <div className="grid grid-cols-8">
        <div className="col-span-2 sm:col-span-2 md:col-span-2 lg:col-span-1 xl:col-span-1 2xl:col-span-1">
          <h6 className="whitespace-nowrap">Page not found</h6>
        </div>
        <div className="col-span-4">
          <div className="flex flex-col w-full gap-2">
            <a
              className="navigate-link"
              href={`${window.config.MAIN_WEBSITE_URL}`}
            >
              Return to main website
            </a>
            <a
              className="navigate-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/account/login");
              }}
            >
              Return to login page
            </a>
            <a
              className="navigate-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/account/forgot-password");
              }}
            >
              Return to forgot password page
            </a>
            <a
              className="navigate-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/account/register");
              }}
            >
              Return to register page
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
